<script lang="ts" setup>
import { LIcon } from '@wgg.hyve/hyve-ui-library'
import type { Document } from '@/libs/api/insurance/insurance.types.ts'

type Props = {
  document: Document
}
defineProps<Props>()
</script>

<template>
  <div class="document-list-item">
    <LIcon class="document-list-item__icon" icon="lnx-download" />
    <a :href="document.link" class="document-list-item__text" target="_blank">{{
      document.title
    }}</a>
  </div>
</template>

<style lang="scss" scoped>
@import 'document-list-item';
</style>
